import {
  VuexModule,
  Module,
  getModule,
  Action,
  Mutation,
} from 'vuex-module-decorators';

import store from '@/store';
import { ErrorAlertModule } from '@/store/modules/errors';
import { getStatementInfoToShow } from '@/api/statements';
import { CommonObject } from '@/utils/types';
import { errorHandler } from "@/utils/common";

export interface IStatementInfoToShowState {
  entity: CommonObject | null;
  loading: boolean;
  loaded: boolean;
}

@Module({ dynamic: true, store, name: 'statementInfoToShow', namespaced: true })
class StatementInfoToShow
  extends VuexModule
  implements IStatementInfoToShowState {
  entity: CommonObject | null = null;
  loading = false;
  loaded = false;

  @Mutation
  pending() {
    ErrorAlertModule.setErrorAlert('');
    this.entity = null;
    this.loading = true;
    this.loaded = false;
  }

  @Mutation
  fulfilled(payload: CommonObject) {
    this.entity = payload;
    this.loading = false;
    this.loaded = true;
  }

  @Mutation
  rejected(payload: unknown) {
    this.loading = false;
    errorHandler(payload)
  }

  @Action
  async getStatementInfoToShow(id: string) {
    this.pending();

    try {
      const statementInfoToShow = await getStatementInfoToShow(id);
      this.fulfilled(statementInfoToShow);
    } catch (error) {
      this.rejected(error);
    }
  }
}

export const StatementInfoToShowModule = getModule(StatementInfoToShow);
